export const featureKey = 'genesysCloudExternalContacts';
